import { Card, CardBody, Col } from "reactstrap";
import { TextColors } from "../../../../Constant";
import { TEXT_COLORS, TEXT_COLOR_DATA } from "../../../../Data/UiKit/HelperClasses";
import CommonCardHeader from "../../../../Common/CommonCardHeader";

const TextColorsCart = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={TextColors} span={TEXT_COLOR_DATA} />
        <CardBody>
          <div className="d-flex align-items-center mb-2 gap-2">
            <div className="font-primary">This is a font-primary text used class as ."font-primary</div>
          </div>
          {TEXT_COLORS.map((item, index) => (
            <div className="d-flex align-items-center mb-2 gap-2" key={index}>
              <div className={item}>{`This is a font-primary text used class as .${item}`}</div>
            </div>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default TextColorsCart;
